import { render, staticRenderFns } from "./IntervenePlanTumorPic.vue?vue&type=template&id=fdf80c14&scoped=true"
import script from "./IntervenePlanTumorPic.vue?vue&type=script&lang=js"
export * from "./IntervenePlanTumorPic.vue?vue&type=script&lang=js"
import style0 from "./IntervenePlanTumorPic.vue?vue&type=style&index=0&id=fdf80c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf80c14",
  null
  
)

export default component.exports